import { createApi, retry } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "api";
import {
  PurchaseHistoryPointList,
  PurchaseHistoryTicket,
  PurchaseHistoryTicketList,
} from "models";
import { ApiRoute } from "utils";

const DEFAULT_PAGE = " ";
const DEFAULT_FILTER = "all";

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 });
export const purchaseHistoryApi = createApi({
  reducerPath: "purchaseHistoryApi",
  tagTypes: ["PurchaseHistory"],
  baseQuery: baseQueryWithRetry,
  keepUnusedDataFor: 60 * 5,
  endpoints: (build) => ({
    // Purchase Ticket History List
    listPurchaseHistory: build.query<
      PurchaseHistoryTicketList,
      {
        pageArg: number;
        desiredTypeFilterArg: string;
      }
    >({
      query: (arg) => {
        const { pageArg, desiredTypeFilterArg } = arg;
        return {
          url: `${ApiRoute.PURCHASE_TICKETS}?desired_type_filter=${
            desiredTypeFilterArg || DEFAULT_FILTER
          }&page=${pageArg || DEFAULT_PAGE}`,
          validateStatus: (response, result) =>
            response.status === 200 && !result.isError,
        };
      },
      providesTags: ["PurchaseHistory"],
      transformResponse: (response: { data: PurchaseHistoryTicketList }) => {
        return response.data;
      },
    }),

    // Purchase Ticket History Detail
    detailPurchaseHistory: build.query<PurchaseHistoryTicket, { id: number }>({
      query: (args) => {
        return {
          url: `${ApiRoute.CURRENT_USER.PURCHASE_HISTORY.LIST}/${args.id}`,
          validateStatus: (response, result) =>
            response.status === 200 && !result.isError,
        };
      },
      providesTags: ["PurchaseHistory"],
      transformResponse: (response: {
        data: { order: PurchaseHistoryTicket };
      }) => {
        return response.data.order;
      },
    }),

    // Purchase Point History List
    listPurchaseHistoryPoint: build.query<
      PurchaseHistoryPointList,
      {
        pageArg: number;
      }
    >({
      query: (arg) => {
        const { pageArg } = arg;
        return {
          url: `${ApiRoute.PURCHASE_POINT}?page=${pageArg || DEFAULT_PAGE}`,
          validateStatus: (response, result) =>
            response.status === 200 && !result.isError,
        };
      },
      providesTags: ["PurchaseHistory"],
      transformResponse: (response: { data: PurchaseHistoryPointList }) => {
        return response.data;
      },
    }),
  }),
});

export const {
  useListPurchaseHistoryQuery,
  useDetailPurchaseHistoryQuery,
  useListPurchaseHistoryPointQuery,
} = purchaseHistoryApi;
